import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import { Grid } from "@mui/material";
import { useContext, useEffect } from "react";
import { ProviderProjectDashboard } from "../ProjectSupportDashboard";

const ProjectChart = () => {

    const {
        lstProjectChart,
    } = useContext(ProviderProjectDashboard);


    useEffect(() => {
        Graph1();
    }, [lstProjectChart])

    const Graph1 = () => {

        am4core.addLicense("CH208466903"); //รหัสรายเส้นใช้ไม่ให้ขึ้นเส้นโลโก้
        let chart = am4core.create("chartdiv", am4charts.XYChart);

        const arrData = lstProjectChart.map((item) => {
            let resultData = {
                "year": item.sYear,
                "Approval": item.nApproval,
                "NotApproval": item.nNotApproval
            };
            return resultData;
        });
        chart.data = arrData

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 20;

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.min = 0;
        valueAxis.extraMax = 0.1;
        valueAxis.numberFormatter.numberFormat = '#,###'
        valueAxis.strictMinMax = true;
        valueAxis.calculateTotals = true;
        valueAxis.title.text = "จำนวนโครงการ";
        valueAxis.title.fontWeight = "bold";

        // Create series
        function createSeries(field, name, stacked) {
            let series = chart.series.push(new am4charts.ColumnSeries());
            series.dataFields.valueY = field;
            series.dataFields.categoryX = "year";
            series.name = name;
            series.columns.template.tooltipText = "{name}: [bold]{valueY}[/] โครงการ";
            series.stacked = stacked;
            series.columns.template.width = am4core.percent(50);

            let bullet = series.bullets.push(new am4charts.LabelBullet())
            bullet.interactionsEnabled = false
            bullet.dy = 20;
            bullet.label.text = '{valueY}'
            bullet.label.fill = am4core.color('#ffffff')
        }
     

        createSeries("Approval", "อนุมัติ", false);
        createSeries("NotApproval", "ไม่อนุมัติ", false);

        // Add legend
        chart.legend = new am4charts.Legend();
    }
    return (
        <>

            <Grid item xs={12} md={12}>
                <div id="chartdiv" style={{ width: "100%", height: "450px" }}></div>
            </Grid>
        </>
    )
}
export default ProjectChart